import { ErrorDataResponse } from '../../interfaces';
import { store } from '../../index';
import * as MyKeysApiDevices from '../../core/apis/mykeys/devices';
import { AT } from '../../actions/actionTypes';
import { getColumns } from '../../components/devicesPage/columns';
import {
  Device,
  State,
  SearchPageRes,
  SearchPageSuccessPL,
  SearchPageFetchPL,
  FilterCritria,
  SearchPageErrorPL,
} from './model';
import { TotalsByTypeDefault } from './defaults';
import * as DTHelper from '../datatable/utils';
import * as DT from '../datatable';
import * as Helper from './utils';
import { SortCriteria } from '../datatable';
import {
  buildCriteraList,
  getDevicesFromSNFilter,
  getDevicesFromSNLabelFilter,
} from '../../core/apis/mykeys/searchCriteria';
import { doAction } from '../../core/redux/store';
import { msgSearchError } from './utils';
import { FeedbackAddPL } from '../../models';
import { setModal } from '../dialogs/actions';
import { Modals } from '../dialogs/model';
import Logger from '../../libs/logger';   import { LogArea } from '../../libs/logger/const';

export const getState = (): State => store.getState().devicesState;

export const openSearchViaFile = () => setModal(Modals.DEVICE_SEARCHFILE);

export const filterViaFile = (file: string) => {
  const filter = Helper.parseInputDevicesCSV(file);
  setModal('');
  doAction<string>(AT.DEVICES.SEARCHVF_SUCCESS, filter);
};

/* Datatable Actions */

export const changeTablePage = (pageNumber: number) =>
  store.dispatch(DT.changeTablePage(AT.DEVICES.TABLE_PAGE_CHANGE, pageNumber));

export const changeTableSizePage = (pageSize: number) =>
  store.dispatch(
    DT.changeTableSizePage(AT.DEVICES.TABLE_PAGESIZE_CHANGE, pageSize)
  );

export const changeTableSorting = (sort: SortCriteria[]) =>
  store.dispatch(
    DT.changeTableSorting(AT.DEVICES.SORT_CRITERIA_UPADATED, sort)
  );

export const updateTableItemSelection = (item: Device) =>
  store.dispatch(
    DT.updateTableItemSelection(AT.DEVICES.TABLE_TOGGLE_ITEM, item)
  );

export const updateTableSelectAll = () => {
  store.dispatch({ type: AT.DEVICES.TABLE_TOGGLE_ALL });
};

export const isTableItemSelected: DT.IsItemSelectedType<Device> = (o) =>
  DTHelper.isTableItemSelected(o, getState().selection);

export const clearSelection = () =>
  store.dispatch({ type: AT.DEVICES.CLEAR_SELECTION });
export const updateFilterCriteria = (
  criteria: FilterCritria,
  isLoading: boolean
) => {
  if (isLoading) return;
  store.dispatch({
    type: AT.DEVICES.FILTER_CRITERIA_UPADATED,
    payload: criteria,
  });
};

export const updateColumns = (columns: DT.TableColumn[]) => {
  store.dispatch({ type: AT.DEVICES.TABLE_COLUMNS, payload: columns });
};
export const updateColumnsByUser = (userRoles: string[]) =>
  updateColumns(getColumns(userRoles));

/* Server Actions */
export const searchPage = (pageNumber: number) => {
  const state = getState();
  const page = DTHelper.getDataPage(state.data.pages, pageNumber);

  if (page && page.isFetching) return;

  const basePayload: DT.SearchPageBasePayload = {
    pageNumber,
    version: state.data.version,
  };

  MyKeysApiDevices.searchPage(pageNumber, state)
    .then((res: SearchPageRes) => {
      const payload = { ...res, ...basePayload };
      doAction<SearchPageSuccessPL>(AT.DEVICES.SEARCH_SUCCESS, payload);
    })
    .catch((err: ErrorDataResponse) => {
      Logger.warn([err], LogArea.Redux);
      doAction<SearchPageErrorPL>(AT.DEVICES.SEARCH_ERROR, basePayload);
      doAction<FeedbackAddPL>(AT.FEEDBACK_ADD_ERROR, {
        content: [msgSearchError],
      });
    });

  doAction<SearchPageFetchPL>(AT.DEVICES.SEARCH_FETCH, basePayload);
};

export const deactivate = (devicesToRemove: string[]) => {
  Logger.info(
    ['remove devices clicked', devicesToRemove],
    LogArea.Redux
  );
  const deviceIds = devicesToRemove ? Helper.parseKeys(devicesToRemove) : [];

  MyKeysApiDevices.deactivate(deviceIds)
    .then((data: boolean) =>
      store.dispatch({
        type: AT.DEVICES.REMOVE_SUCCESS,
        payload: data,
      })
    )
    .catch((err: ErrorDataResponse) =>
      store.dispatch({ type: AT.DEVICES.REMOVE_ERROR, payload: err })
    );

  store.dispatch({ type: AT.DEVICES.REMOVE_FETCH });
};

export const activate = (devicesToActivate: string[]) => {
  Logger.info(
    ['activate devices clicked', devicesToActivate],
    LogArea.Redux
  );
  const deviceIds = devicesToActivate
    ? Helper.parseKeys(devicesToActivate)
    : [];

  MyKeysApiDevices.activate(deviceIds)
    .then((data: boolean) =>
      store.dispatch({
        type: AT.DEVICES.ACTIVATE_SUCCESS,
        payload: data,
      })
    )
    .catch((err: ErrorDataResponse) =>
      store.dispatch({ type: AT.DEVICES.ACTIVATE_ERROR, payload: err })
    );

  store.dispatch({ type: AT.DEVICES.ACTIVATE_FETCH });
};

export const getCriteria = () => {
  const devicesState = getState();
  return buildCriteraList(devicesState.filters, devicesState.sort);
};

export const getDevicesSNFilter = () => {
  const snInput = getState().filters.serialNumber;
  const deviceIds = getDevicesFromSNFilter(String(snInput));
  return deviceIds;
};

export const getDevicesLabelsFilter = () => {
  const snInput = getState().filters.snLabel;
  const labels = getDevicesFromSNLabelFilter(snInput);
  return labels;
};

export const getCriteriaDevices = () => {
  const devicesState = getState();
  return buildCriteraList(devicesState.filters, devicesState.sort);
};

export const getTotals = (keys: string[] = []) => {
  const deviceState = getState();
  const { data } = deviceState;

  return (
    (keys.length > 0
      ? Helper.getTotalsFromSelectedKeys(keys, data)
      : data.totalsByType) || TotalsByTypeDefault
  );
};
